// Bootstrap Core Dependencies (Order Matters)
import "bootstrap/js/dist/util/index.js";
import "bootstrap/js/dist/dom/data.js";
import "bootstrap/js/dist/dom/event-handler.js";
import "bootstrap/js/dist/dom/manipulator.js";
import "bootstrap/js/dist/dom/selector-engine.js";
import "bootstrap/js/dist/util/config.js";
import "bootstrap/js/dist/base-component.js";
import "bootstrap/js/dist/util/scrollbar.js";
import "bootstrap/js/dist/util/backdrop.js";
import "bootstrap/js/dist/util/focustrap.js";
import "bootstrap/js/dist/util/component-functions.js";

// Bootstrap components
import "bootstrap/js/dist/modal.js";
import "bootstrap/js/dist/offcanvas.js";
import "bootstrap/js/dist/tab.js";

// accordion
import "bootstrap/js/dist/collapse.js";

// 
import './custom.js';